export { RefundPolicy as default } from 'core/common/components/TechPages';
